import React, { useState, useEffect } from 'react';
import "./ResultPage.css";
import Dashboard from '../Dashboard/Dashboard';
import lockIcon from "../../images/lock1.svg";
import girl from "../../images/girl.png";
import star from "../../images/star.png";
import redb from "../../images/red-badge.svg";
import buttonloader from "../../images/buttonloader.gif";
import { END_URL, IMG_URL, ASSET_URL } from "../../config";

function ResultPage({ resultRef,subs, Has, plan, onLoginChange, subplan, token, testdata, subcribed, result, demension, badge,TestLink,handleSub }) {
    const LoginShow = () => {
        // window.scrollTo({ top: 0, behavior: 'smooth' });
        onLoginChange(true);
    };

    const [ButtonLoad, setButtonLoad] = useState(false);

   
    const HandlePayment = (item) => {

        const InitializePayment = async () => {

            try {

                setButtonLoad(true);

                const response = await fetch(`${END_URL}/test-payment`, {

                    method: "POST",
                    headers: {

                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },

                    body: JSON.stringify(item)

                });

                const data = await response.json();

                console.log(data.payment, 'fetch data');

                if (data.payment) {

                    setButtonLoad(false);
                    window.location.href = data.payment;

                } else {

                    setButtonLoad(false);

                    console.error("Invalid response:", data);
                    alert("An error occurred while processing the request.");
                }

            } catch (error) {

                console.error("Error sending result:", error);
            }
        };

        InitializePayment();

    };


   const handleNavigete = (link) => {
    
        if (link) {
        window.location.href = `/${link}`;
        }
    };


    return (
        <div className='result-cont1' ref={resultRef}  >
            <div className="resut-main">
                <div className="result-box1">
                    {!subs &&
                        <div className="result-box1-inner">
                            <h5>{demension?.name} {result.map(item => item.final_letter).join(' ')}</h5>
                            {token ? (
                                <button
                                
                                    // onClick={() => HandlePayment(Has)}
                                    
                                    onClick={
                                            TestLink === "free_result"
                                            ? () => handleSub(demension?.unlock_full_result)
                                            : TestLink
                                            ? () => handleNavigete(TestLink)
                                            : () => handleSub(demension?.unlock_full_result)
                                        }
                                
                                >
                                    <span><img src={lockIcon} alt="" /></span>
                                    Unlock full results {ButtonLoad && <img src={buttonloader} alt="Loading" />}
                                </button>

                            ) : (
                                <button onClick={LoginShow}>
                                    <span><img src={lockIcon} alt="" /></span>
                                    Unlock full results
                                </button>
                            )}
                        </div>
                    }
                </div>
                <div className="result-box2 result-box2-block">

                    <div className="result-box2-t1-side">
                        <div className="result-box2-t1-side-a1-outer">

                            <div
                                className={`result-box2-t1-side-a1 ${`${IMG_URL}/${demension?.image_url}` === `${ASSET_URL}/assets/images/image.jpeg`
                                    ? 'result-box2-t1-side-a1-default'
                                    : ''
                                    }`}
                            >
                                <img src={`${IMG_URL}/${demension?.image_url}`} alt="" />
                            </div>
                        </div>
                        <div className="result-box2-t1-side-a2">

                            <div className="result-box2-t1-side-a2-txt">
                                <span>
                                    <img src={redb} alt="red badge" />
                                </span>
                                <span>{demension?.name}</span>

                            </div>
                            <p>{demension?.badge_description}</p>
                        </div>
                    </div>

                    {demension?.dimensionDescription &&
                        <div className="result-box2-t1">
                            <div className="result-box2-t1-P1">
                                <p><img src={`${IMG_URL}/${demension?.image}`} alt="" /></p>
                                <div dangerouslySetInnerHTML={{ __html: demension.dimensionDescription }} />
                            </div>
                        </div>
                    }

                </div>

            </div>


        </div>
    );
}

export default ResultPage;
